var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-center" },
    [
      !_vm.loading
        ? [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass: "btn-group",
                  attrs: { "data-toggle": " buttons" }
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      class:
                        _vm.currentShowsurveypolicynotice == 0 ? "active" : "",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.currentShowsurveypolicynotice = 0
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm._f("translate")("Disabled")) +
                          "\n                "
                      )
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      class:
                        _vm.currentShowsurveypolicynotice == 1 ? "active" : "",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.currentShowsurveypolicynotice = 1
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm._f("translate")("Inline text")) +
                          "\n                "
                      )
                    ]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      class:
                        _vm.currentShowsurveypolicynotice == 2 ? "active" : "",
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          _vm.currentShowsurveypolicynotice = 2
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm._f("translate")("Collapsible text")) +
                          "\n                "
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._m(0),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.currentShowsurveypolicynotice > 0,
                    expression: "currentShowsurveypolicynotice > 0"
                  }
                ],
                staticClass: "cointainer-center"
              },
              [
                _vm.languageChangerEnabled
                  ? _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c("language-selector", {
                          attrs: {
                            elId: "questioneditor",
                            aLanguages: _vm.$store.state.languages,
                            parentCurrentLanguage:
                              _vm.$store.state.activeLanguage
                          },
                          on: { change: _vm.selectLanguage }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _c("div", { staticClass: "row scoped-editor-row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-sm-6 ls-space margin top-5 bottom-5 scope-contains-ckeditor"
                    },
                    [
                      _c("label", { attrs: { for: "inputdataseclabel" } }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("translate")(
                              "Survey data policy checkbox label:"
                            )
                          ) + ":"
                        )
                      ]),
                      _c(
                        "div",
                        { staticClass: "scoped-keep-in-line" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.currentDataseclabel,
                                expression: "currentDataseclabel"
                              }
                            ],
                            staticClass: "form-control has-counter",
                            attrs: {
                              type: "text",
                              id: "inputdataseclabel",
                              name: "surveyls_policy_notice_label",
                              maxlength: this.maxDataSecLabelLength
                            },
                            domProps: { value: _vm.currentDataseclabel },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.currentDataseclabel = $event.target.value
                              }
                            }
                          }),
                          _c("type-counter", {
                            attrs: {
                              countable: _vm.currentDataseclabel.length,
                              "max-value": this.maxDataSecLabelLength,
                              valid: _vm.inputValid
                            }
                          })
                        ],
                        1
                      )
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-sm-6 ls-space margin top-5 bottom-5 " },
                    [
                      _c("div", {
                        staticClass: "col-sm-12 well",
                        domProps: {
                          innerHTML: _vm._s(_vm.translate("__INFOTEXT"))
                        }
                      })
                    ]
                  )
                ]),
                _c("div", { staticClass: "row scoped-editor-row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-sm-12 ls-space margin top-5 bottom-5 scope-contains-ckeditor "
                    },
                    [
                      _c("div", { staticClass: "ls-flex-row col-12" }, [
                        _c("div", { staticClass: "ls-flex-item text-left" }, [
                          _c("label", {}, [
                            _vm._v(
                              _vm._s(_vm._f("translate")("Description")) + ":"
                            )
                          ])
                        ]),
                        _vm.$store.state.permissions.update
                          ? _c(
                              "div",
                              { staticClass: "ls-flex-item text-right" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-default btn-xs",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.sourceEditEnable = !_vm.sourceEditEnable
                                      }
                                    }
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "fa fa-file-code-o"
                                    }),
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("translate")(
                                          "Toggle source mode"
                                        )
                                      )
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e()
                      ]),
                      !_vm.$store.state.permissions.update
                        ? _c("div", {
                            staticClass: "col-12",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.stripScripts(_vm.currentDatasecmessage)
                              )
                            }
                          })
                        : _vm._e(),
                      !_vm.sourceEditEnable &&
                      _vm.$store.state.permissions.update
                        ? _c("lsckeditor", {
                            attrs: {
                              editor: _vm.datasecmessageEditorObject,
                              config: _vm.datasecmessageEditorData
                            },
                            model: {
                              value: _vm.currentDatasecmessage,
                              callback: function($$v) {
                                _vm.currentDatasecmessage = $$v
                              },
                              expression: "currentDatasecmessage"
                            }
                          })
                        : _vm._e(),
                      _vm.sourceEditEnable &&
                      _vm.$store.state.permissions.update
                        ? _c("aceeditor", {
                            attrs: {
                              thisID: "datasecmessageSourceEditor",
                              showLangSelector: false
                            },
                            model: {
                              value: _vm.currentDatasecmessage,
                              callback: function($$v) {
                                _vm.currentDatasecmessage = $$v
                              },
                              expression: "currentDatasecmessage"
                            }
                          })
                        : _vm._e(),
                      _vm.$store.state.permissions.update
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.currentDatasecmessage,
                                expression: "currentDatasecmessage"
                              }
                            ],
                            attrs: {
                              type: "hidden",
                              name: "surveyls_policy_notice"
                            },
                            domProps: { value: _vm.currentDatasecmessage },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.currentDatasecmessage = $event.target.value
                              }
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]
            )
          ]
        : _vm._e(),
      _vm.loading
        ? _c(
            "div",
            [_c("loader-widget", { attrs: { id: "textelementsloader" } })],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [_c("hr")])
  }
]
render._withStripped = true

export { render, staticRenderFns }